import { render, staticRenderFns } from "./userGroupAction.vue?vue&type=template&id=e996b306&scoped=true"
import script from "./userGroupAction.vue?vue&type=script&lang=js"
export * from "./userGroupAction.vue?vue&type=script&lang=js"
import style0 from "./userGroupAction.vue?vue&type=style&index=0&id=e996b306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e996b306",
  null
  
)

export default component.exports